import { render, staticRenderFns } from "./SalesData.vue?vue&type=template&id=ba7fae9e&scoped=true"
import script from "./SalesData.vue?vue&type=script&lang=js"
export * from "./SalesData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7fae9e",
  null
  
)

export default component.exports